import { TabStyles } from '@tableau/widgets';

import { cssClass, textEllipsis } from '../../style';

export namespace PublishFlowSuccessDialogStyles {
  const prefix = 'flow-publish-success';

  export const flowIconResource = 'tb-prep-flow-icon';

  export const datasourceIconResource = 'tb-data-pane-datasource-icon';

  export const modal = cssClass(prefix, 'modal', {
    textAlign: 'left',
  });

  export const items = cssClass(prefix, 'items', {
    display: 'flex',
    flexDirection: 'column',
  });

  export const item = cssClass(prefix, 'item', {
    display: 'flex',
    alignItems: 'center',
  });

  export const icon = cssClass(prefix, 'icon', {
    flex: '0 0 auto',
  });

  export const name = cssClass(prefix, 'name', textEllipsis, {
    fontSize: TabStyles.Typography.Sizing.Default,
    fontWeight: 'bold',
    paddingLeft: '2px',
  });

  export const title = cssClass(prefix, 'title', {
    paddingBottom: TabStyles.Spacing.DefaultSpace,
    fontSize: '14px',
    fontWeight: 'normal'
  });

  export const datasources = cssClass(prefix, 'datasources', {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: TabStyles.Spacing.MediumSpace,
  });
}
